import type { FC } from 'react';

import { FacebookIcon } from '@eneco/sparky/icons';

import ShareButton from './ShareButton';

const NETWORK_URL = 'https://www.facebook.com/sharer/sharer.php';
const NETWORK_PARAMETERS = {
  url: 'u',
};

type Props = {
  label: string;
};

const FacebookButton: FC<Props> = ({ label }) => (
  <ShareButton label={label} networkParameters={NETWORK_PARAMETERS} networkUrl={NETWORK_URL}>
    <FacebookIcon />
  </ShareButton>
);

export default FacebookButton;
